module.exports = __webpack_public_path__ + "src/components/DBPagination/right.svg?06ea4d14";


//////////////////
// WEBPACK FOOTER
// ./src/components/DBPagination/right.svg
// module id = 2785
// module chunks = 1